import styles from '../../index.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <a
        href="https://github.com/dldvk9999/react-validate-component"
        target="_blank"
        rel="norefferer nofollow noopener"
        className={styles.github}
      >
        github
      </a>
    </footer>
  );
}
